
import { IOhInvestigation } from "../models/onHandDelivery";
import {
  CHECK_BOX_MSG,
  CreateDynamicSchema,
  FieldConfig,
  OPTION_MSG,
  RequiredField,
} from "./formik";

// Configuration array defining validation rules
const config: FieldConfig[] = [
  RequiredField("hasEmailEntryError", OPTION_MSG),
  RequiredField("wereAllPartiesContactedWithOhn", OPTION_MSG),
  RequiredField("wasCommunicationSuccessful", OPTION_MSG),
  RequiredField("isF18NotesAccurate", CHECK_BOX_MSG, true, "string", true),
  RequiredField("wasOhnSentByCreditDept", OPTION_MSG),
];

// Function to create a Yup validation schema dynamically from the config array

// Exporting the dynamically created schema
export const onHandInvestigationSchema = CreateDynamicSchema(config);

export const intiOnHandInvestigationFormValue: IOhInvestigation = {
  hasEmailEntryError: undefined,
  wereAllPartiesContactedWithOhn: undefined,
  wasCommunicationSuccessful: undefined,
  isF18NotesAccurate: undefined,
  wasOhnSentByCreditDept: undefined,
};
